export default "__VITE_ASSET__ae1122a2__"